import React from "react";
import { Chip } from "@mui/material";

// Maps the status strings used across projects, invoices, timesheets and
// expenses onto a semantic colour, so status reads the same on every screen.
const STATUS_COLORS = {
  active: "success",
  approved: "success",
  paid: "success",
  completed: "success",
  submitted: "info",
  pending: "warning",
  draft: "default",
  inactive: "default",
  rejected: "error",
  overdue: "error",
  cancelled: "error",
  canceled: "error",
};

export default function StatusChip({ status, size = "small", ...rest }) {
  if (status === null || status === undefined || status === "") return null;

  const key = String(status).toLowerCase().trim();
  const tone = STATUS_COLORS[key] || "default";
  const label = String(status).charAt(0).toUpperCase() + String(status).slice(1);

  if (tone === "default") {
    return <Chip label={label} size={size} {...rest} />;
  }

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        bgcolor: `${tone}.soft`,
        color: `${tone}.main`,
        fontWeight: 600,
        border: "none",
        ...rest.sx,
      }}
      {...rest}
    />
  );
}
